/**************************************************
 * Nombre:       Tarjeta_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {KeyboardArrowRight, KeyboardArrowUp} from "@mui/icons-material";

const Tarjeta_Caracteristicas = ({item, escodigo, setEsgogido}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    onClick={() => item.nombre === escodigo ? setEsgogido('') : setEsgogido(item.nombre)}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{cursor: 'pointer'}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 28, fontWeight: 500}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 1}} sx={{justifyContent: 'flex-start'}}>
                        {escodigo === item.nombre ?

                            <KeyboardArrowUp/>
                            :
                            <KeyboardArrowRight/>

                        }
                    </Grid>

                </Grid>

            </Grid>

            <Collapse in={escodigo === item.nombre} sx={{width: '100%'}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>{item.descripcion}</Typography>
                </Grid>
            </Collapse>

        </Grid>
    )

}
export default Tarjeta_Caracteristicas